@if (showPanel$ | async) {
  <section id="inboxes">
    <div class="sidebar-group mat-elevation-z1">
      <mat-icon>inbox</mat-icon><span transloco="INBOXES"></span>
      <span class="spacer"></span>
      <app-navigation-expansion-button
        [isExpanded]="(isExpanded$ | async)!"
        (isExpandedChange)="onExpandChanged()"
      ></app-navigation-expansion-button>
    </div>
    @if (isInboxesLoading$ | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (isExpanded$ | async) {
      <section id="inbox-items">
        @for (inbox of inboxes$ | async; track inbox) {
          <app-navigation-inbox
            [dbId]="(dbId$ | async)!"
            [inbox]="inbox"
          ></app-navigation-inbox>
        }
      </section>
    }
  </section>
}
